/**
 * @class
 * @param {T.DatePicker.Par} par
 * @extends mkE.Base
 */
T.DatePicker = Class(
	/**
	 * @lends {T.DatePicker#}
	 */
	{
		/** @param {T.DatePicker.Par} par */
		__construct: function(par){
			/** @type {Array.<T.DatePickerDate>} */
			this._dateOptions = {};
			this.format = par.format || 'Y-m-d';
			this.type = par.type || T.DatePicker.TYPE_SINGLE;
			this.onchange = par.onchange || function(){
			};
			this.onMonthChange = par.onMonthChange || function(){
			};
			this.onDateClick = par.onDateClick || this.onDateClick;
			this.onclick = par.onclick || function(){
			};
			this.disableBefore = par.disableBefore || '';
			this.disableAfter = par.disableAfter || '';
			this.addScroll = par.addScroll || false;
			this.monthPicker = par.monthPicker || false;
			this.showButtons = par.showButtons || false;
			this.onSelect = par.onSelect || function(){
			};
			this.onCancel = par.onCancel || function(){
			};
			var className = ['datePicker'];
			switch( this.type ){
				case T.DatePicker.TYPE_RANGE:
					this._value = {
						from: '',
						to: ''
					};
					className.push('datePickerRange');
					break;
				case T.DatePicker.TYPE_MULTI:
					this._value = {};
					className.push('datePickerMulti');
					break;
				//case T.DatePicker.TYPE_SINGLE:
				default:
					className.push('datePickerSingle');
					this.type = T.DatePicker.TYPE_SINGLE;
					this._value = '';
			}
			var date = new D.Date();
			if( par.time ){
				date.setTime(par.time);
			} else if( par.date ){
				date.fromFormat(this.format, par.date);
			}
			this._year = date.getYear();
			this._month = date.getMonth();
			this._header = new T.DatePicker.Header({
				onprev: D.closure(this, this.prevMonth),
				onnext: D.closure(this, this.nextMonth),
				onclick: D.closure(this, this._showMonthChoice)
			});
			this.node = mkE({
				tag: 'div',
				className: className.join(' '),
				style: {
					zIndex: 2002
				},
				prop: {
					onclick: D.closure(this, this._onclick)
				}
			});
			this._drawCalendar();
			if( par.value ){
				this.value(par.value);
			}
		},

		_onclick: function(){
			$(this).trigger('click');
		},

		prevMonth: function(){
			--this._month;
			if( this._month == 0 ){
				this._month = 12;
				--this._year;
			}
			this._drawCalendar();
			if( this._tmpStart ){
				return;
			}
			var date = new D.Date(this._year, this._month, 1);
			this.onMonthChange(date.format(this.format));
		},

		nextMonth: function(){
			++this._month;
			if( this._month == 13 ){
				this._month = 1;
				++this._year;
			}
			this._drawCalendar();
			if( this._tmpStart ){
				return;
			}
			var date = new D.Date(this._year, this._month, 1);
			this.onMonthChange(date.format(this.format));
		},

		_drawCalendar: function(){
			if( this.monthPicker ){
				this._showMonthChoice();
				return;
			}
			clearNode(this.node);
			this._header.caption(D.Lang.get('date.month.i' + this._month) + ', ' + this._year);
			this._header.append(this.node);
			this._makeGrid().append(this.node);

			if( this.type === T.DatePicker.TYPE_RANGE ){
				var m = this._month++, y = this._year;
				if( m >= 12 ){
					this._month = 1;
					this._year++;
				}
				this._header.captionRight(D.Lang.get('date.month.i' + this._month) + ', ' + this._year);
				this._makeGrid(1).append(this.node);
				this._month = m;
				this._year = y;
				T.clear().append(this.node);
			}

			if( this.showButtons ){
				this._drawButtons();
			}
		},

		_drawButtons: function(){
			this._buttons = mkE({
				tag: 'div',
				className: 'footer',
				els: [
					{
						tag: 'div',
						className: 'button',
						text: D.Lang.get('cancel'),
						color: 'link',
						onclick: this.onCancel
					},
					{
						tag: 'div',
						className: 'button',
						text: D.Lang.get('select'),
						onclick: this.onSelect
					}
				]
			}).append(this.node);
		},

		_makeGridDaysRow: function(){
			var tr = {
				tag: 'tr',
				els: []
			};
			for( let i = 1; i <= 7; i++ ){
				tr.els.push({
					tag: 'th',
					text: D.Lang.get('date.day.short.i' + i)
				})
			}
			return mkE(tr);
		},

		_isSelected: function(sqlDate){
			switch( this.type ){
				case T.DatePicker.TYPE_RANGE:
					if( !this._value.from || !this._value.to ){
						return false;
					}
					return sqlDate >= this._value.from && sqlDate <= this._value.to;
				case T.DatePicker.TYPE_MULTI:
					return isset(this._value[sqlDate]);
				case T.DatePicker.TYPE_SINGLE:
					return this._value == sqlDate;
			}
			return false;
		},

		_makeGrid: function(i){
			var disableBefore = this._fromFormattedToSql(this.disableBefore);
			var disableAfter = this._fromFormattedToSql(this.disableAfter);
			if( !i ){
				this._gridDateNodes = {};
			}
			var tbody;
			var table = mkE({
				tag: 'table',
				className: 'datePickerGrid',
				els: [
					tbody = mkE({
						tag: 'tbody',
						els: [
							this._makeGridDaysRow()
						]
					})
				]
			});
			var nextMonth = (this._month == 12 ? 1 : this._month + 1);
			var date = new D.Date();
			date.setDate(1).setMonth(this._month).setYear(this._year);
			date.setTime(date.getTime() - 3600 * 24 * (date.dayOfWeek() - 1));
			var tr;
			for( ; ; ){
				var dow = date.dayOfWeek();
				var sqlDate = date.toSqlDate();
				if( dow == 1 ){
					tr = mkE({
						tag: 'tr'
					}).append(tbody);
				}
				if( !tr ){
					break;
				}
				var dateNode = mkE({
					tag: 'td',
					className: ('day' + dow),
					prop: {
						onclick: D.closure(this, this._dateOnclick, date.getYear(), date.getMonth(), date.getDate()),
						onmouseover: D.closure(this, this._dateOnMouseOver, date.getYear(), date.getMonth(), date.getDate())
					},
					els: [
						{
							tag: 'div',
							text: date.getDate()
						}
					]
				}).append(tr);
				if( sqlDate == this._tmpStart ){
					addClassName(dateNode, 'start');
				}
				if( this._isSelected(sqlDate) ){
					addClassName(dateNode, 'selected');
				}
				if( disableBefore && sqlDate < disableBefore ){
					addClassName(dateNode, 'disabled');
				}
				if( disableAfter && sqlDate > disableAfter ){
					addClassName(dateNode, 'disabled');
				}
				var options = this._dateOptions[sqlDate];
				if( options ){
					if( options.className ){
						addClassName(dateNode, options.className);
					}
					if( options.disabled ){
						addClassName(dateNode, 'disabled');
					}
					if( options.title ){
						dateNode.title = options.title;
					}
				}
				if( date.getMonth() == this._month ){
					this._gridDateNodes[sqlDate] = dateNode;
				} else{
					addClassName(dateNode, 'otherMonth');
				}
				if( date.getMonth() == nextMonth && date.dayOfWeek() == 7 ){
					break;
				}
				date.setTime(date.getTime() + 3600 * 24);
				if( date.getMonth() == nextMonth && date.dayOfWeek() == 1 ){
					break;
				}
			}
			return table;
		},

		_dateOnMouseOver: function(y, m, d){
			if( this.type !== T.DatePicker.TYPE_RANGE || !this._tmpStart ){
				return false;
			}

			var date = new D.Date();
			date.setDate(d).setMonth(m).setYear(y);
			var sqlDate = date.toSqlDate(),
				from = this._tmpStart < sqlDate ? this._tmpStart : sqlDate,
				to = this._tmpStart > sqlDate ? this._tmpStart : sqlDate;

			var dateNode;
			for( var i in this._gridDateNodes ){
				dateNode = this._gridDateNodes[i];
				if( i >= from && i <= to ){
					addClassName(dateNode, 'hover');
				} else{
					removeClassName(dateNode, 'hover');
				}
			}
		},

		/**
		 * @param {Number} y
		 * @param {Number} m
		 * @param {Number }d
		 * @param {String} formatted
		 */
		onDateClick: function(formatted, y, m, d){
		},

		_dateOnclick: function(y, m, d, e){
			e = D.event(e);
			D.stopPropagation(e);
			$(this).trigger('click');
			var date = new D.Date().resetTime().setYear(y).setMonth(m).setDate(d);
			var sqlDate = date.toSqlDate();
			var disableBefore = this._fromFormattedToSql(this.disableBefore);
			if( disableBefore && sqlDate < disableBefore ){
				return;
			}
			var disableAfter = this._fromFormattedToSql(this.disableAfter);
			if( disableAfter && sqlDate > disableAfter ){
				return;
			}
			var formatted = date.format(this.format);
			var options = this._dateOptions[sqlDate];
			if( options ){
				if( options.disabled ){
					return;
				}
				if( options.onclick && options.onclick(y, m, d, formatted) === false ){
					return;
				}
			}
			if( this.onDateClick(formatted, y, m, d) === false ){
				return;
			}
			switch( this.type ){
				case T.DatePicker.TYPE_RANGE:
					if( this._tmpStart ){
						if( sqlDate > this._tmpStart ){
							this.value({
								from: this._tmpStart,
								to: sqlDate,
								skipRedraw: true
							});
						} else{
							this.value({
								from: sqlDate,
								to: this._tmpStart,
								skipRedraw: true
							});
						}
						this._tmpStart = null;
					} else{
						this._tmpStart = sqlDate;
						this.value(false);
					}
					break;
				case T.DatePicker.TYPE_MULTI:
					if( this._value[sqlDate] ){
						delete this._value[sqlDate];
					} else{
						this._value[sqlDate] = true;
					}
					break;
				case T.DatePicker.TYPE_SINGLE:
					this._value = sqlDate;
					break;
			}
			this._drawCalendar();
			$(this).trigger('change');
		},

		_showMonthChoice: function(){
			this._tmpYear = this._year;
			this.drawMonthChoice();
		},

		drawMonthChoice: function(){
			clearNode(this.node);
			this._monthHeader = new T.DatePicker.Header({
				caption: this._tmpYear,
				onprev: D.closure(this, this._monthChoicePrev),
				onnext: D.closure(this, this._monthChoiceNext),
				onclick: D.closure(this, this.drawYearChoice)
			});
			this._monthHeader.append(this.node);
			this._monthGrid().append(this.node);
		},

		_monthChoicePrev: function(){
			--this._tmpYear;
			this.drawMonthChoice();
		},

		_monthChoiceNext: function(){
			++this._tmpYear;
			this.drawMonthChoice();
		},

		_monthGrid: function(){
			var tbody;
			var table = mkE({
				tag: 'table',
				className: 'datePickerGrid datePickerMonthGrid',
				els: [
					tbody = mkE({
						tag: 'tbody'
					})
				]
			});
			var tr, monthNode, sqlMonth;
			var disableBefore = this.disableBefore ? (new D.Date()).fromFormat(this.format, this.disableBefore).format('Y-m') : '';
			var disableAfter = this.disableAfter ? (new D.Date()).fromFormat(this.format, this.disableAfter).format('Y-m') : '';
			for( var i = 0; i < 12; ++i ){
				if( i % 4 == 0 ){
					tr = mkE({
						tag: 'tr'
					}).append(tbody);
				}

				sqlMonth = (new D.Date()).setYear(this._tmpYear).setMonth(i + 1).setDate(1).format('Y-m');
				monthNode = mkE({
					tag: 'td',
					text: D.Lang.get('date.month.i' + String(i + 1)).substr(0, 3),
					prop: {
						onclick: D.closure(this, this._monthClick, i + 1)
					}
				}).append(tr);

				if( this._month == (i + 1) && this._year == this._tmpYear ){
					addClassName(monthNode, 'selected');
				}
				if( disableBefore && sqlMonth < disableBefore ){
					addClassName(monthNode, 'disabled');
				}
				if( disableAfter && sqlMonth > disableAfter ){
					addClassName(monthNode, 'disabled');
				}
			}
			return table;
		},

		_monthClick: function(m, e){
			this._year = this._tmpYear;
			this._month = m;
			if( this.monthPicker ){
				this._dateOnclick(this._year, this._month, 1, e);
				return;
			}
			this._drawCalendar();
		},

		drawYearChoice: function(){
			clearNode(this.node);
			this._yearChoiceYear = this._tmpYear;
			this._yearHeader = new T.DatePicker.Header({
				onprev: D.closure(this, this._yearChoicePrev),
				onnext: D.closure(this, this._yearChoiceNext),
				onclick: D.closure(this, this._drawCalendar)
			});
			this._yearChoiceCaption();
			this._yearHeader.append(this.node);
			this._yearGrid().append(this.node);
		},

		_yearChoiceCaption: function(){
			this._yearHeader.caption((this._yearChoiceYear - 6) + ' - ' + (this._yearChoiceYear + 5));
		},

		_yearChoicePrev: function(){
			this._yearChoiceYear -= 10;
			clearNode(this.node);
			this._yearChoiceCaption();
			this._yearHeader.append(this.node);
			this._yearGrid().append(this.node)
		},

		_yearChoiceNext: function(){
			this._yearChoiceYear += 10;
			clearNode(this.node);
			this._yearChoiceCaption();
			this._yearHeader.append(this.node);
			this._yearGrid().append(this.node)
		},

		_yearGrid: function(){
			var tbody;
			var table = mkE({
				tag: 'table',
				className: 'datePickerGrid datePickerMonthGrid',
				els: [
					tbody = mkE({
						tag: 'tbody'
					})
				]
			});
			var tr, yearNode, year;
			var disableBefore = this.disableBefore ? (new D.Date()).fromFormat(this.format, this.disableBefore).getYear() : false;
			var disableAfter = this.disableAfter ? (new D.Date()).fromFormat(this.format, this.disableAfter).getYear() : false;
			for( var i = -6; i < 6; ++i ){
				if( (i + 6) % 4 == 0 ){
					tr = mkE({
						tag: 'tr'
					}).append(tbody);
				}
				year = this._yearChoiceYear + i;
				yearNode = mkE({
					tag: 'td',
					text: (year),
					prop: {
						onclick: D.closure(this, this._yearClick, year)
					}
				}).append(tr);
				if( this._year == year ){
					addClassName(yearNode, 'selected');
				}
				if( disableBefore && year < disableBefore ){
					addClassName(yearNode, 'disabled');
				}
				if( disableAfter && year > disableAfter ){
					addClassName(yearNode, 'disabled');
				}
			}
			return table;
		},

		_yearClick: function(y){
			this._tmpYear = y;
			this.drawMonthChoice();
		},

		/**
		 * @param {String} date
		 * @param {T.DatePickerDate|Object} options
		 */
		dateOptions: function(date, options){
			var d = new D.Date();
			d.fromFormat(this.format, date);
			if( !d.getTime() ){
				return;
			}
			if( !options ){
				delete this._dateOptions[d.toSqlDate()];
				return;
			}
			this._dateOptions[d.toSqlDate()] = options;
			this._drawCalendar();
		},

		_fromSqlToFormatted: function(v){
			if( !v ){
				return '';
			}
			var d = new D.Date();
			d.fromSqlDate(v);
			if( !d.getTime() ){
				return '';
			}
			return d.format(this.format);
		},

		_fromFormattedToSql: function(v){
			if( !v ){
				return '';
			}
			let d;
			if(typeof v === 'number') {
				d = new D.Date(v);
			} else {
				d = new D.Date();
				d.fromFormat(this.format, v);
			}
			if( !d.getTime() ){
				return '';
			}
			return d.toSqlDate();
		},

		/**
		 * @param {*} [v]
		 * @returns {*}
		 */
		value: function(v){
			if( !isset(v) ){
				switch( this.type ){
					case T.DatePicker.TYPE_RANGE:
						if( !this._value.to && this._tmpStart ){
							return {
								from: this._tmpStart,
								to: this._tmpStart
							}
						}
						return {
							from: this._fromSqlToFormatted(this._value.from),
							to: this._fromSqlToFormatted(this._value.to)
						};
					case T.DatePicker.TYPE_MULTI:
						var re = [];
						for( var k in this._value ){
							re.push(this._fromSqlToFormatted(k));
						}
						return re;
					case T.DatePicker.TYPE_SINGLE:
						return this._fromSqlToFormatted(this._value);
				}
			}
			switch( this.type ){
				case T.DatePicker.TYPE_RANGE:
					this._value = {
						from: '',
						to: ''
					};
					if( v && typeof v == 'object' ){
						if( v.from ){
							this._value.from = this._fromFormattedToSql(v.from);
						}
						if( v.to ){
							this._value.to = this._fromFormattedToSql(v.to);
						}
						if( !v.skipRedraw && this._value.from ){
							var date = new D.Date();
							date.fromSqlDate(this._value.from);
							this._month = date.getMonth();
							this._year = date.getYear()
						}
					}
					break;
				case T.DatePicker.TYPE_MULTI:
					this._value = {};
					if( v ){
						for( var k in v ){
							this._value[this._fromFormattedToSql(v[k])] = true;
						}
						for( var k in this._value ){
							var date = new D.Date();
							date.fromSqlDate(k);
							this._month = date.getMonth();
							this._year = date.getYear();
							break;
						}
					}
					break;
				case T.DatePicker.TYPE_SINGLE:
					this._value = '';
					if( v ){
						this._value = this._fromFormattedToSql(v);
						var date = new D.Date();
						date.fromSqlDate(this._value);
						this._month = date.getMonth();
						this._year = date.getYear();
					}
					break;
			}
			this._drawCalendar();
		},

		bindToInput: function(input){
			if( this._bindInput ){
				return;
			}
			this._bindInput = input;
			$(this).bind('change', D.closure(this, this._btiOnchange));
			$(this).bind('click', D.closure(this, this._btiOnclick));
			$(input).bind('focus', D.closure(this, this._datePickerShow));
			$(input).bind('blur', D.closure(this, this._datePickerHide));
			this.value(this._bindInput.value);
			this._bindInput.datepicker = this;
		},

		_btiOnchange: function(){
			this._bindInput.value = this.value();
			this._bindInput.blur();
			this.remove();
			$(this._bindInput).trigger('change');
		},

		_btiOnclick: function(){
			clearTimeout(this._datePickerTO);
			this._bindInput.focus();
		},

		_datePickerShow: function(){
			addClassName(this.node, 'datePickerFloating');
			clearTimeout(this._datePickerTO);
			var pos = D.position(this._bindInput);
			var left = pos.left;
			var top = pos.top + this._bindInput.offsetHeight;
			var addScroll = this.addScroll || InfoBox.opened;
			if( addScroll ){
				left += $(window).scrollLeft() - $('.InfoBox').scrollLeft();
				top += $(window).scrollTop() - $('.InfoBox').scrollTop();
			}
			this.node.style.position = 'absolute';
			this.node.style.left = left + 'px';
			this.node.style.top = top + 'px';
			this.append(document.body);

			if( addScroll ){
				var wndHeight = $(window).height();
				if( top > wndHeight ){
					this.node.style.top = parseInt(this.node.style.top.replace('px', '')) - this._bindInput.offsetHeight - $(this.node).height() - 2 + 'px';
				}
			}
		},

		_datePickerHide: function(){
			this._datePickerTO = setTimeout(D.closure(this, this.remove), 200);
		}

	},
	mkE.Base
);

T.DatePicker.TYPE_SINGLE = 'single';
T.DatePicker.TYPE_RANGE = 'range';
T.DatePicker.TYPE_MULTI = 'multi';
T.DatePicker.days = ['monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday', 'sunday'];

T.DatePickerDate = function(){
};

//T.DatePickerDate.prototype.date = '';
T.DatePickerDate.prototype.className = '';
T.DatePickerDate.prototype.disabled = false;
T.DatePickerDate.prototype.title = '';
T.DatePickerDate.prototype.onclick = function(y, m, d, formatted){
};

/**
 * @class
 */
T.DatePicker.Par = Class(
	/**
	 * @lends {T.DatePicker.Par#}
	 */
	{
		/** @type {int} */
		time: null,
		/** @type {string} */
		date: null,
		/** @type {string} */
		type: null,
		/** @type {string} */
		format: null,
		/** @type {string} */
		value: null,
		/** @type {closure} */
		onchange: function(){
		},
		/** @type {closure} */
		onMonthChange: function(){
		},
		/** @type {closure} */
		onDateClick: function(formatted, y, m, d){
		},
		/** @type {closure} */
		onclick: function(){
		},
		/** @type {string} */
		disableBefore: null,
		/** @type {string} */
		disableAfter: null,
		/** @type {boolean} */
		addScroll: null,
		/** @type {boolean} */
		monthPicker: null,
		/** @type {boolean} */
		showButtons: null,
		/** @type {closure} */
		onSelect: function(){
		},
		/** @type {closure} */
		onCancel: function(){
		},
		/**
		 * @param {closure} v
		 * @return {T.DatePicker.Par}
		 */
		setOnCancel: function(v){
			this.onCancel = v;
			return this;
		},
		/**
		 * @param {closure} v
		 * @return {T.DatePicker.Par}
		 */
		setOnSelect: function(v){
			this.onSelect = v;
			return this;
		},
		/**
		 * @param {boolean} v
		 * @return {T.DatePicker.Par}
		 */
		setShowButtons: function(v){
			this.showButtons = v;
			return this;
		},
		/**
		 * @param {boolean} v
		 * @return {T.DatePicker.Par}
		 */
		setMonthPicker: function(v){
			this.monthPicker = v;
			return this;
		},
		/**
		 * @param {boolean} v
		 * @return {T.DatePicker.Par}
		 */
		setAddScroll: function(v){
			this.addScroll = v;
			return this;
		},
		/**
		 * @param {string} v
		 * @return {T.DatePicker.Par}
		 */
		setDisableAfter: function(v){
			this.disableAfter = v;
			return this;
		},
		/**
		 * @param {string} v
		 * @return {T.DatePicker.Par}
		 */
		setDisableBefore: function(v){
			this.disableBefore = v;
			return this;
		},
		/**
		 * @param {closure} v
		 * @return {T.DatePicker.Par}
		 */
		setOnclick: function(v){
			this.onclick = v;
			return this;
		},
		/**
		 * @param {closure} v
		 * @return {T.DatePicker.Par}
		 */
		setOnDateClick: function(v){
			this.onDateClick = v;
			return this;
		},
		/**
		 * @param {closure} v
		 * @return {T.DatePicker.Par}
		 */
		setOnMonthChange: function(v){
			this.onMonthChange = v;
			return this;
		},
		/**
		 * @param {closure} v
		 * @return {T.DatePicker.Par}
		 */
		setOnchange: function(v){
			this.onchange = v;
			return this;
		},
		/**
		 * @param {string} v
		 * @return {T.DatePicker.Par}
		 */
		setValue: function(v){
			this.value = v;
			return this;
		},
		/**
		 * @param {string} v
		 * @return {T.DatePicker.Par}
		 */
		setFormat: function(v){
			this.format = v;
			return this;
		},
		/**
		 * @param {string} v
		 * @return {T.DatePicker.Par}
		 */
		setType: function(v){
			this.type = v;
			return this;
		},
		/**
		 * @param {string} v
		 * @return {T.DatePicker.Par}
		 */
		setDate: function(v){
			this.date = v;
			return this;
		},
		/**
		 * @param {int} v
		 * @return {T.DatePicker.Par}
		 */
		setTime: function(v){
			this.time = v;
			return this;
		}
	}
);

/**
 * @class
 * @param par
 * @extends mkE.Base
 */
T.DatePicker.Header = Class(
	/**
	 * @lends {T.DatePicker.Header#}
	 */
	{
		/** @param par */
		__construct: function(par){
			this.onclick = par.onclick || function(){
			};
			this.onprev = par.onprev || function(){
			};
			this.onnext = par.onnext || function(){
			};
			this.node = mkE({
				tag: 'div',
				className: 'datePickerHead radius3',
				els: [
					{
						tag: 'table',
						els: [
							{
								tag: 'tbody',
								els: [
									{
										tag: 'tr',
										els: [
											{
												tag: 'td',
												className: 'prev',
												prop: {
													onclick: D.closure(this, this._onprev)
												},
												attr: {
													align: 'center'
												},
												els: [
													{tag: 'div'}
												]
											}, //
											this._titleNode = mkE({
												tag: 'td',
												prop: {
													onclick: D.closure(this, this._onclick)
												}
											}),
											this._titleNext = mkE({
												tag: 'td',
												className: 'next',
												prop: {
													onclick: D.closure(this, this._onnext)
												},
												attr: {
													align: 'center'
												},
												els: [
													{tag: 'div'}
												]
											})
										]
									} // tr
								]
							} // tbody
						]
					}
				]
			});
			if( par.caption ){
				this.caption(par.caption);
			}
		},

		caption: function(v){
			clearNode(this._titleNode);
			mkE.appendTypeElement(this._titleNode, v);
		},

		captionRight: function(v){
			if( !this._titleNodeRight ){
				this._titleNodeRight = mkE({
					tag: 'td',
					prop: {
						onclick: D.closure(this, this._onclick)
					}
				});
				D.insertBefore(this._titleNodeRight, this._titleNext);
				addClassName(this.node, 'multi');
			}
			clearNode(this._titleNodeRight);
			mkE.appendTypeElement(this._titleNodeRight, v);
		},

		_onclick: function(){
			this.onclick();
		},

		_onprev: function(){
			this.onprev();
		},

		_onnext: function(){
			this.onnext();
		}
	},
	mkE.Base
);